import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient, } from '@angular/common/http';
import { Login } from 'src/app/shared/models/login';
import { CookieService } from 'ngx-cookie-service';
import { UsuarioService } from '../services/usuario/usuario.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private cookies: CookieService, private usuarioServices: UsuarioService) {

  }


  login(login: Login): Observable<any> {

    return this.http.post<any>(`${environment.urlBack}/loginLDAP`, login, { observe: 'events' }).pipe(tap(
      (res: any) => {
        return res;
      })
    );
  }


  /*getTokenApi(): Observable<any> {
    return this.http.post<any>(`${environment.urlBack}/api/proxy/login`, {}).pipe(
      tap(res => res)
    );
  }*/

  authenticate(): Observable<any> {
    let login = new Login(environment.userApi.username, environment.userApi.password);
    return this.http.post<any>(`${environment.urlBack}/authenticate`, login).pipe(tap(
      (res: any) => {
        return res;
      })
    );
  }
  logout() {
    this.cookies.deleteAll();
    localStorage.removeItem('ET_EMYRfiltroActividadesHome');
    localStorage.removeItem('ET_EMYRfiltroAsignadas');
    localStorage.removeItem('ET_EMYRfiltroNoAsignadas');
    localStorage.removeItem('ET_EMYRuser');
    localStorage.removeItem('ET_EMYRordenCampoPendientes');
    localStorage.removeItem('ET_EMYRordenTipoPendientes');
    localStorage.removeItem('ET_EMYRordenTipoProcesados');
    localStorage.removeItem('ET_EMYRordenCampoProcesados');
  }

}
